import { h, RefObject, createRef } from 'preact'
import classNames from 'classnames'

function updateTooltipContainerPosition(tooltipContainerRef: RefObject<HTMLDivElement>) {
  const tooltipContainer = tooltipContainerRef.current
  const boundingClientRect = tooltipContainer?.getBoundingClientRect()
  const viewportPositionX = `${boundingClientRect?.x}px`

  tooltipContainer?.style.setProperty('--tooltip-container-position-x', viewportPositionX)
}

const Tooltip = ({
  trigger,
  qaClasses,
  customClasses,
  tooltipMessage,
  withArrow,
  position,
  noWrap,
  top
}: {
  trigger: string | JSX.Element
  qaClasses?: string
  customClasses?: string
  tooltipMessage: string | JSX.Element
  withArrow?: boolean
  position?: string
  noWrap?: boolean
  top?: number
}) => {
  const tooltipContainerRef = createRef<HTMLDivElement>()

  return (
    <div
      className='tooltip-container'
      ref={tooltipContainerRef}
      onMouseOver={() => updateTooltipContainerPosition(tooltipContainerRef)}
    >
      <span className={classNames('tooltip-trigger', qaClasses)}>{trigger}</span>
      {tooltipMessage && (
        <div
          className={classNames(customClasses, 'tooltip-message', {
            'tooltip-message--no-wrap': noWrap,
            [`tooltip-message--${position}`]: position
          })}
          style={{ top: top && `${top}px` }}
        >
          {withArrow && <i className='arrow' />}
          {tooltipMessage}
        </div>
      )}
    </div>
  )
}

export default Tooltip
